import React from "react";
import { Wrapper, Image } from "./styled";
import Icon from "../../../../images/check_circle.svg";

const CheckIcon = () => {
  return (
    <Wrapper>
      <Image src={Icon} alt="icon" />
    </Wrapper>
  );
};

export default CheckIcon;
